/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Grid, Rating, Tab, Typography } from '@mui/material';
import { DatePickers, DialogForm, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { AccessRoleDTO, AccessRoleFilterDTO, CompanyDTO, CompanyFilterDTO, OportunityDTO, OportunityFilterDTO, PeopleFilterDTO, UserDTO, ValueListDTO } from '../../../shared/interfaces';
import { formatDateTime } from '../../../shared/utils';
import { TabContext, TabList, TabPanel } from '@mui/lab';

interface IOportunityMaintenanceProps {
    data: any;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const OportunityMaintenance: React.FC<IOportunityMaintenanceProps> = ({ data, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {

    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);
    const [sourceList, setSourceList] = useState<ValueListDTO[]>([]);
    const [priorityList, setPriorityList] = useState<ValueListDTO[]>([]);
    const [ownerList, setOwnerList] = useState<UserDTO[]>([]);
    const [requesterList, setRequesterList] = useState<UserDTO[]>([]);
    const [userList, setUserList] = useState<UserDTO[]>([]);
    const [companyList, setCompanyList] = useState<CompanyDTO[]>([]);
    const [oportunityDTO, setOportunityDTO] = useState<OportunityDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const [value, setValue] = React.useState('1');

    const [accessRolePermissionDTO, setAccessRolePermissionDTO] = useState<AccessRoleDTO>();
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');

    useEffect(() => {
        setOportunityDTO({
            ...oportunityDTO,
            id: '',
            name: '',
            code: 'OP-00000',
            description: '',
            statusId: ListId.clientsphere.oportunity.startStatus,
            kanbanIndex: 0,
            estimateValue: 'R$ 0,00',
            successProbability: '50%',
            OwnerId: userInfo.user.companyId,
            SourceId: '',
            PriorityId: '',
            Qualification: '',
            oportunityId: '',
            startDateTime: new Date(),
            expectedClosingDateTime: new Date(),
            companyId: ''
        } as OportunityDTO);

        if (isOpenMaintenance) {
            handleListGetAll(ListId.clientsphere.oportunity.statusId, setStatusList);
            handleListGetAll(ListId.clientsphere.oportunity.sourceId, setSourceList);
            handleListGetAll(ListId.clientsphere.oportunity.priorityId, setPriorityList);
            handleCompanyGetAll();
            handleUserGetAllAsync();
            handlerPeopleGetAllAsync(userInfo.user.companyId, setOwnerList);
            handleGetOportunityByIdAsync();

            handleGetPermission(ListId.clientsphere.oportunityId, setAccessRolePermissionDTO);

        }
    }, [data, isOpenMaintenance]);

    const handleGetPermission = useCallback(async (featureId: string, setList: any) => {
        const accessRoleFilterDTO: AccessRoleFilterDTO = {
            featureId: featureId,
            userId: userInfo.user.id,
        };
        GenericService.PostGenericAsync1('authsphere.AccessRole', 'GetPermissionAsync', accessRoleFilterDTO, setActionExecuted, setLoading, undefined, setList,);
    }, []);

    useEffect(() => {
        handlerPeopleGetAllAsync(oportunityDTO?.companyId || '', setRequesterList);
    }, [oportunityDTO?.companyId]);

    const handleListGetAll = useCallback(async (listId: string, setList: any) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: 'valueindex, value ASC'
        };
        GenericService.GetAllAsync1('parmsphere.valueList', valueListFilterDTO, setLoading, setList, showMessage);
    }, []);

    const handlerPeopleGetAllAsync = useCallback(async (companyId: string, setUserList: any) => {
        if (companyId === undefined || companyId === '') {
            return;
        }
        const peopleFilterDTO: PeopleFilterDTO = {
            name: '',
            fullName: '',
            typeId: '',
            statusId: '',
            jobTitleId: '',
            companyId: companyId
        };
        GenericService.GetAllAsync1('corpsphere.people', peopleFilterDTO, setLoading, setUserList, showMessage);
    }, []);

    const handleCompanyGetAll = useCallback(async () => {
        const companyFIlterDTO: CompanyFilterDTO = {
            name: '',
            businessRelationshipTypeId: '',
            statusId: '',
            orderBy: 'name ASC'
        };
        GenericService.GetAllAsync1('corpsphere.company', companyFIlterDTO, setLoading, setCompanyList, showMessage);
    }, []);

    const handleUserGetAllAsync = useCallback(async () => {
        const userFilterDTO = {
            companyId: '',
        };
        GenericService.GetAllViewAsync1('authsphere.user', userFilterDTO, setActionExecuted, setLoading, setUserList, showMessage, false);

    }, []);

    const handleOwnerGetAllAsync = useCallback(async () => {
        const userFilterDTO = {
            companyId: userInfo.user.CompanyId,
        };
        GenericService.GetAllAsync1('authsphere.user', userFilterDTO, setLoading, setOwnerList, showMessage);
    }, []);

    const handleGetOportunityByIdAsync = useCallback(async () => {
        GenericService.GetByIdAsync1('clientsphere.oportunity', data.id, setLoading, setOportunityDTO, showMessage);
    }, [data]);

    const handleSaveClick = useCallback(async () => {
        const dto = oportunityDTO as OportunityDTO;

        if (oportunityDTO?.id === '' || oportunityDTO?.id === undefined) {
            dto.createdById = userInfo.user.id;
            dto.code = companyList.find(x => x.id === dto.companyId)?.code;

            GenericService.AddAsync1('clientsphere.oportunity', dto, setOportunityDTO, setActionExecuted, setLoading, showMessage);
        }
        else {
            if (!accessRolePermissionDTO?.allowUpdate) {
                showMessage('There is no permission for this access.', 'info');
                return;
            }
            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('clientsphere.oportunity', dto, setActionExecuted, setLoading, showMessage);
        }
    }, [oportunityDTO]);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);

        if (oportunityDTO?.id === '' && Number(newValue) > 2)
            handleSaveClick();
    };

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);

        if (type != 'success')
            setIsOpenMaintenance(true);
    }

    const actions: IDialogActions[] = [
        { id: 'save', text: 'Save', icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick },
        { id: 'cancel', text: 'Cancel', icon: 'cancel_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title='OPORTUNITY DETAILS'
                icon='grid_view_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'lg'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <TabContext value={value} >
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                                        <Tab label={'Details'} value="1" />
                                        <Tab label={'Scope'} value="2" />
                                        <Tab label={'Scope AI'} value="3" />
                                    </TabList>
                                </Box>
                                <TabPanel value="1" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='companyId'
                                                label='Company'
                                                placeholder='Company'
                                                value={oportunityDTO?.companyId}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                valueList={companyList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextFieldInput
                                                id='name'
                                                label='Name'
                                                value={oportunityDTO?.name}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                required={true}
                                                maxLength={200}
                                                autoFocus={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldInput
                                                id='code'
                                                label='Code'
                                                value={oportunityDTO?.code}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                required={true}
                                                maxLength={20}
                                                readonly={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='requesterId'
                                                label='Requester'
                                                placeholder='Owner'
                                                value={oportunityDTO?.requesterId}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                valueList={requesterList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='statusId'
                                                label='Status'
                                                placeholder='Status'
                                                value={oportunityDTO?.statusId}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                valueList={statusList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldInput
                                                id='estimatedValue'
                                                label='Estimated Value R$'
                                                value={oportunityDTO?.estimatedValue}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                required={true}
                                                maxLength={20}
                                                numericOnly={true}
                                                valueType='currency'
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldInput
                                                id='successProbability'
                                                label='Suceess Probability'
                                                value={oportunityDTO?.successProbability}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                required={true}
                                                maxLength={20}
                                                autoFocus={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <SelectField
                                                id='sourceId'
                                                label='Source'
                                                placeholder='Source'
                                                value={oportunityDTO?.sourceId}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                valueList={sourceList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldInput
                                                id='externalCode'
                                                label='External Code'
                                                value={oportunityDTO?.externalCode}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                required={true}
                                                maxLength={200}
                                                autoFocus={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='ownerId'
                                                label='Owner'
                                                placeholder='Owner'
                                                value={oportunityDTO?.ownerId}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                valueList={ownerList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <SelectField
                                                id='priorityId'
                                                label='Priority'
                                                placeholder='Priority'
                                                value={oportunityDTO?.priorityId}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                valueList={priorityList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <Typography component='legend'>Qualification</Typography>
                                            <Rating
                                                name='simple-controlled'
                                                value={5}
                                                size='small'
                                                onChange={(event, newValue) => {
                                                    // setOportunityDTO();
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextFieldInput
                                                id='startDateTime'
                                                label='Start'
                                                value={oportunityDTO?.startDateTime}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                type='datetime-local'
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextFieldInput
                                                id='expectedClosingDateTime'
                                                label='Expected Closing'
                                                value={oportunityDTO?.expectedClosingDateTime}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                type='datetime-local'
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='description'
                                                label='Description'
                                                value={oportunityDTO?.description}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                required={true}
                                                maxLength={400}
                                                autoFocus={false}
                                                multiline={true}
                                                rows={10}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="2" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='scope'
                                                label='Scope'
                                                value={oportunityDTO?.scope}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                required={true}
                                                maxLength={4000}
                                                autoFocus={false}
                                                multiline={true}
                                                rows={20}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="3" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='scopeAI'
                                                label='Scope AI'
                                                value={oportunityDTO?.scopeAI}
                                                setValue={setOportunityDTO}
                                                obj={oportunityDTO}
                                                required={false}
                                                maxLength={4000}
                                                autoFocus={false}
                                                multiline={true}
                                                rows={20}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                            </TabContext>
                        </Grid>
                        {oportunityDTO?.id ? (
                            <React.Fragment>
                                <Grid item xs={12} md={4}>
                                    <TextFieldReadOnly
                                        id={'id'}
                                        label='Id'
                                        value={oportunityDTO.id}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'createdById'}
                                        label='Created By'
                                        value={userList.find(x => x.id === oportunityDTO.createdById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'creationDateTime'}
                                        label='Creation Date'
                                        value={formatDateTime(String(oportunityDTO.creationDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updatedById'}
                                        label='Updated By'
                                        value={userList.find(x => x.id === oportunityDTO.updatedById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updateDateTime'}
                                        label='Update Date'
                                        value={formatDateTime(String(oportunityDTO.updateDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : undefined}
                    </Grid>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};